// 共通デザイントークン（シャドウ最小化ポリシー）
const designTokens = {
  borderRadius: 8,
  spacing: 8,
  elevation: {
    none: 'none',
  },
  outline: {
    subtle: '1px solid',
  },
};

export default designTokens;


